export interface DeleteApplication {
    applicationId: number;
}

export const DeleteApplicationInit: DeleteApplication = {
    applicationId: 0,
}